// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseSuccessFragmentDoc } from './fragments/loginResponseSuccess.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AutologinDocument = gql`
    mutation autologin($authToken: String!, $isConsultant: Boolean!) {
  autologin(authToken: $authToken) {
    __typename
    ... on LoginResponseSuccess {
      ...loginResponseSuccess
    }
  }
}
    ${LoginResponseSuccessFragmentDoc}`;

export function useAutologinMutation() {
  return Urql.useMutation<SchemaTypes.AutologinMutation, SchemaTypes.AutologinMutationVariables>(AutologinDocument);
};